import { TdsModalHelp } from '../shared/TdsModalHelp'
import { HelpIcon, IconButton } from './styledComponents'
import type { HelpProps } from './types'


const Help = (props: HelpProps) => {
  const { claimHelp, claimHeader, pageName } = props

  return (
    <HelpIcon>
      <IconButton
        type="button"
        role="button"
        aria-label={pageName}
        title={pageName}
        id="help-icon-button"
        data-trigger-modal={pageName}
      >
        <svg width="24px" height="24px" viewBox="0 0 24 24">
          {/* eslint-disable-next-line max-len */}
          <path d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M13,15 C13,15.5522847 12.5522847,16 12,16 C11.4477153,16 11,15.5522847 11,15 L11,13 C11,12.4477153 11.4477153,12 12,12 C13.0567153,12 14,11.0567153 14,10 C14,8.94328475 13.0567153,8 12,8 C11.2715152,8 10.4440852,8.59096137 10.1240755,9.32200582 C9.90260611,9.82794035 9.31292872,10.0585449 8.80699418,9.83707551 C8.30105965,9.61560611 8.0704551,9.02592872 8.29192449,8.51999418 C8.91845775,7.08871377 10.4428118,6 12,6 C14.1612847,6 16,7.83871525 16,10 C16,11.8177738 14.6993209,13.4073668 13,13.8667418 L13,15 Z M12,19 C11.4477153,19 11,18.5522847 11,18 C11,17.4477153 11.4477153,17 12,17 C12.5522847,17 13,17.4477153 13,18 C13,18.5522847 12.5522847,19 12,19 Z"></path>
        </svg>
      </IconButton>
      {
      <TdsModalHelp claimHeader={claimHeader} pageName={pageName}>
        <span>{claimHelp}</span>
      </TdsModalHelp>
      }
    </HelpIcon>
  )
}


export { Help }
